export interface AdObject {
  displayDuration?: number;
  adSign?: boolean;
  allowSkip?: boolean;
  skipTime?: number;
  images?: {
    src: string;
    href: string;
    fileName: string;
  }[];
  videos?: {
    src: string;
    href: string;
    fileName: string;
  }[];
  name: string;
  showRemaining?: boolean;
  target?: string;
  type?: 'BANNER' | 'VIDEO';
}

export interface AdCuePoint {
  time: 'START' | 'END' | string;
  id: string;
}

export interface ParsedAdCuePoint {
  timestamp: number;
  id: string;
  cuePoint: AdCuePoint;
}

export type AdType = 'PREROLL' | 'MIDROLL' | 'POSTROLL';

export type AdsProvider = {
  /** Return a list of cue points where ads should be shown */
  cuePoints: () => Promise<AdCuePoint[] | undefined>;
  /** Return an Ad for the specied type */
  getAd: (
    t: AdType,
    cuePointId: string,
    isLive: boolean
  ) => Promise<AdObject | undefined>;
  /** In case of livestreams, return the expected total length of the stream in seconds */
  getExpectedLiveStreamLength: () => number;
  adsSettings?: Partial<AdPluginSettings>;
};

export interface AdStrings {
  skip: string;
  'skip in': string;
  advertisement: string;
  'video start in': string;
}

export const DEFAULT_STRINGS: AdStrings = {
  skip: 'Skip Ad',
  'skip in': 'Skip Ad in ',
  advertisement: 'Advertisement',
  'video start in': 'Video will start in: ',
}; // Language entries for translation

export interface AdPluginSettings {
  /**
   * The function providing an ad when called.
   */
  adsProvider: AdsProvider;
  /**
   * Language strings for different UI components
   */
  strings: AdStrings;
  /**
   * The minimal interval between ad impressions (seconds)
   */
  minIntervalBetweenAds: number;
}
